/**
 * CollabV3VerifiedRow 컴포넌트
 * @description 유료 카드(참가비 · 모금) 아래의 `Organizer identity verified` 줄(앱
 *   `CollabFundingVerifiedRow`). 보일지는 매퍼가 정한 `isHostVerified` 가 정한다.
 *
 *   앱 카드의 `Details >` 는 두지 않는다 — 웹은 보기 전용이고, 자세히 화면은 앱에만 있다. 앱으로
 *   가는 길은 하단 버튼 하나로 모은다.
 * @example {detail.isHostVerified ? <CollabV3VerifiedRow /> : null}
 */
import { BadgeCheck } from "lucide-react";
import { memo } from "react";

import { collabV3CardStyles } from "./CollabV3Card.styles";

import { COLLAB_V3_CARD_COPY } from "../../constants/collabV3CardCopy";

const CollabV3VerifiedRow = memo(() => (
  <p className={collabV3CardStyles.verified}>
    <BadgeCheck aria-hidden className={collabV3CardStyles.verifiedIcon} />
    {COLLAB_V3_CARD_COPY.verified}
  </p>
));

CollabV3VerifiedRow.displayName = "CollabV3VerifiedRow";

export default CollabV3VerifiedRow;
